import { Component, Input } from "@angular/core"

@Component({
  selector: "ag-notification-badge",
  standalone: false,
  templateUrl: "./ag-notification-badge.component.html",
  styleUrl: "./ag-notification-badge.component.scss",
})
export class AgNotificationBadgeComponent {
  @Input() notification: number = 0
  @Input() size: AgNotificationBadgeSize = "m"
  @Input() maxValue: number = 99
}
//xs -> 6px, s -> 8px, m -> 20px, l -> 24px
export type AgNotificationBadgeSize = "xs" | "s" | "m" | "l"
